import { createFileRoute, redirect } from '@tanstack/react-router'
import { onlineManager } from '@tanstack/react-query'
import { AccountPage } from '@/pages/account/AccountPage'
import { getUserProfileQueryOptions } from '@/queries/query'
import { queryKeys } from '@/queries/keys'

export const Route = createFileRoute('/account')({
  beforeLoad: ({ context }) => {
    if (!context.authContext.isAuthenticated) {
      return redirect({
        to: '/auth/login',
      })
    }
  },
  loader: ({ context }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return context.queryClient.ensureQueryData(getUserProfileQueryOptions())
    }
    return context.queryClient.getQueryData(queryKeys.user.profile())
  },
  component: AccountPage,
})
